/**
 * Minimal subset of Node's util module for playground usage.
 */

export const deprecate = <T extends (...args: any[]) => any>(fn: T, _message: string): T => fn;
export const promisify = <T extends (...args: any[]) => any>(fn: T): ((...args: Parameters<T>) => Promise<ReturnType<T>>) => {
  return (...args: Parameters<T>) => {
    try {
      const result = fn(...args);
      return result instanceof Promise ? result : Promise.resolve(result as ReturnType<T>);
    } catch (err) {
      return Promise.reject(err);
    }
  };
};

export const format = (...args: any[]): string => args.map((value) => {
  if (typeof value === 'string') return value;
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
}).join(' ');

export const inspect = (value: unknown): string => {
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
};

export const stripVTControlCharacters = (input: string): string => {
  return typeof input === 'string' ? input.replace(/[\u001B\u009B][[\]()#;?]*(?:[0-9]{1,4}(?:;[0-9]{0,4})*)?[0-9A-ORZcf-nq-uy=><]/g, '') : '';
};

export const inherits = (ctor: Function | undefined, superCtor: Function | undefined): void => {
  if (typeof ctor !== 'function' || typeof superCtor !== 'function') {
    return;
  }
  Object.setPrototypeOf(ctor.prototype, superCtor.prototype);
  Object.setPrototypeOf(ctor, superCtor);
};

export default {
  deprecate,
  promisify,
  format,
  inspect,
  stripVTControlCharacters,
  inherits,
};
